/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BodyPostV2UploadSubmissionMedia } from "../../models/bodyPostV2UploadSubmissionMedia.ts";

import type { CreatorDetails } from "../../models/creatorDetails.ts";

import type { CreatorsResponse } from "../../models/creatorsResponse.ts";

import type { GetV2BuilderSearchParams } from "../../models/getV2BuilderSearchParams.ts";

import type { GetV2GetMyAgentsParams } from "../../models/getV2GetMyAgentsParams.ts";

import type { GetV2GetSpecificAgentParams } from "../../models/getV2GetSpecificAgentParams.ts";

import type { GetV2ListMarketplaceSkillsParams } from "../../models/getV2ListMarketplaceSkillsParams.ts";

import type { GetV2ListMySubmissionsParams } from "../../models/getV2ListMySubmissionsParams.ts";

import type { GetV2ListStoreAgentsParams } from "../../models/getV2ListStoreAgentsParams.ts";

import type { GetV2ListStoreCreatorsParams } from "../../models/getV2ListStoreCreatorsParams.ts";

import type { GetV2ReadMarketplaceSkillFileParams } from "../../models/getV2ReadMarketplaceSkillFileParams.ts";

import type { GetV2UnifiedSearchAcrossAllContentTypesParams } from "../../models/getV2UnifiedSearchAcrossAllContentTypesParams.ts";

import type { GraphModelWithoutNodes } from "../../models/graphModelWithoutNodes.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { ImageURLResponse } from "../../models/imageURLResponse.ts";

import type { InstalledSkill } from "../../models/installedSkill.ts";

import type { MarketplaceSkillDetails } from "../../models/marketplaceSkillDetails.ts";

import type { MarketplaceSkillsResponse } from "../../models/marketplaceSkillsResponse.ts";

import type { MyUnpublishedAgentsResponse } from "../../models/myUnpublishedAgentsResponse.ts";

import type { PostV2GenerateSubmissionImageParams } from "../../models/postV2GenerateSubmissionImageParams.ts";

import type { PostV2InstallMarketplaceSkillParams } from "../../models/postV2InstallMarketplaceSkillParams.ts";

import type { PostV2UploadSubmissionMediaParams } from "../../models/postV2UploadSubmissionMediaParams.ts";

import type { ProfileDetails } from "../../models/profileDetails.ts";

import type { ProfileUpdateRequest } from "../../models/profileUpdateRequest.ts";

import type { SearchResponse } from "../../models/searchResponse.ts";

import type { SkillSubmission } from "../../models/skillSubmission.ts";

import type { SkillSubmissionRequest } from "../../models/skillSubmissionRequest.ts";

import type { StoreAgentDetails } from "../../models/storeAgentDetails.ts";

import type { StoreAgentsResponse } from "../../models/storeAgentsResponse.ts";

import type { StoreCategoryInfo } from "../../models/storeCategoryInfo.ts";

import type { StoreReview } from "../../models/storeReview.ts";

import type { StoreReviewCreate } from "../../models/storeReviewCreate.ts";

import type { StoreSubmission } from "../../models/storeSubmission.ts";

import type { StoreSubmissionEditRequest } from "../../models/storeSubmissionEditRequest.ts";

import type { StoreSubmissionRequest } from "../../models/storeSubmissionRequest.ts";

import type { StoreSubmissionsResponse } from "../../models/storeSubmissionsResponse.ts";

import type { UnifiedSearchResponse } from "../../models/unifiedSearchResponse.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV2BuilderSearchResponse200 = {
  data: SearchResponse;
  status: 200;
};

export type getV2BuilderSearchResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2BuilderSearchResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2BuilderSearchResponseSuccess =
  getV2BuilderSearchResponse200 & {
    headers: Headers;
  };
export type getV2BuilderSearchResponseError = (
  | getV2BuilderSearchResponse401
  | getV2BuilderSearchResponse422
) & {
  headers: Headers;
};

export type getV2BuilderSearchResponse =
  | getV2BuilderSearchResponseSuccess
  | getV2BuilderSearchResponseError;

export const getGetV2BuilderSearchUrl = (params?: GetV2BuilderSearchParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["by_creator"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/builder/search?${stringifiedParams}`
    : `/api/builder/search`;
};

/**
 * Search for blocks (including integrations), marketplace agents, and user library agents.
 * @summary Builder search
 */
export const getV2BuilderSearch = async (
  params?: GetV2BuilderSearchParams,
  options?: RequestInit,
): Promise<getV2BuilderSearchResponse> => {
  return customMutator<getV2BuilderSearchResponse>(
    getGetV2BuilderSearchUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2BuilderSearchInfiniteQueryKey = (
  params?: GetV2BuilderSearchParams,
) => {
  return [`/api/builder/search`, ...(params ? [params] : [])] as const;
};

export const getGetV2BuilderSearchQueryKey = (
  params?: GetV2BuilderSearchParams,
) => {
  return [`/api/builder/search`, ...(params ? [params] : [])] as const;
};

export const getGetV2BuilderSearchInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    GetV2BuilderSearchParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2BuilderSearchInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    QueryKey,
    GetV2BuilderSearchParams["page"]
  > = ({ signal, pageParam }) =>
    getV2BuilderSearch(
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    TError,
    TData,
    QueryKey,
    GetV2BuilderSearchParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BuilderSearchInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BuilderSearch>>
>;
export type GetV2BuilderSearchInfiniteQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BuilderSearchInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    GetV2BuilderSearchParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BuilderSearchParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          TError,
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BuilderSearchInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    GetV2BuilderSearchParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          TError,
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BuilderSearchInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    GetV2BuilderSearchParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Builder search
 */

export function useGetV2BuilderSearchInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    GetV2BuilderSearchParams["page"]
  >,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2BuilderSearchInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Builder search
 */
export const prefetchGetV2BuilderSearchInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData,
        QueryKey,
        GetV2BuilderSearchParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2BuilderSearchInfiniteQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV2BuilderSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2BuilderSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2BuilderSearch>>
  > = ({ signal }) => getV2BuilderSearch(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2BuilderSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2BuilderSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2BuilderSearch>>
>;
export type GetV2BuilderSearchQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2BuilderSearch<
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2BuilderSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          TError,
          Awaited<ReturnType<typeof getV2BuilderSearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BuilderSearch<
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2BuilderSearch>>,
          TError,
          Awaited<ReturnType<typeof getV2BuilderSearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2BuilderSearch<
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Builder search
 */

export function useGetV2BuilderSearch<
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2BuilderSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Builder search
 */
export const prefetchGetV2BuilderSearchQuery = async <
  TData = Awaited<ReturnType<typeof getV2BuilderSearch>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2BuilderSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2BuilderSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2BuilderSearchQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListStoreAgentsResponse200 = {
  data: StoreAgentsResponse;
  status: 200;
};

export type getV2ListStoreAgentsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListStoreAgentsResponseSuccess =
  getV2ListStoreAgentsResponse200 & {
    headers: Headers;
  };
export type getV2ListStoreAgentsResponseError =
  getV2ListStoreAgentsResponse422 & {
    headers: Headers;
  };

export type getV2ListStoreAgentsResponse =
  | getV2ListStoreAgentsResponseSuccess
  | getV2ListStoreAgentsResponseError;

export const getGetV2ListStoreAgentsUrl = (
  params?: GetV2ListStoreAgentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/agents?${stringifiedParams}`
    : `/api/store/agents`;
};

/**
 * Get a paginated list of agents from the marketplace,
 * with optional filtering and sorting.
 *
 * Used for:
 * - Home Page Featured Agents
 * - Home Page Top Agents
 * - Search Results
 * - Agent Details - Other Agents By Creator
 * - Agent Details - Similar Agents
 * - Creator Details - Agents By Creator
 * @summary List store agents
 */
export const getV2ListStoreAgents = async (
  params?: GetV2ListStoreAgentsParams,
  options?: RequestInit,
): Promise<getV2ListStoreAgentsResponse> => {
  return customMutator<getV2ListStoreAgentsResponse>(
    getGetV2ListStoreAgentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListStoreAgentsInfiniteQueryKey = (
  params?: GetV2ListStoreAgentsParams,
) => {
  return [`/api/store/agents`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListStoreAgentsQueryKey = (
  params?: GetV2ListStoreAgentsParams,
) => {
  return [`/api/store/agents`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListStoreAgentsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    GetV2ListStoreAgentsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListStoreAgentsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    QueryKey,
    GetV2ListStoreAgentsParams["page"]
  > = ({ signal, pageParam }) =>
    getV2ListStoreAgents(
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    TError,
    TData,
    QueryKey,
    GetV2ListStoreAgentsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListStoreAgentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListStoreAgents>>
>;
export type GetV2ListStoreAgentsInfiniteQueryError = HTTPValidationError;

export function useGetV2ListStoreAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    GetV2ListStoreAgentsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: undefined | GetV2ListStoreAgentsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    GetV2ListStoreAgentsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    GetV2ListStoreAgentsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List store agents
 */

export function useGetV2ListStoreAgentsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    GetV2ListStoreAgentsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListStoreAgentsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List store agents
 */
export const prefetchGetV2ListStoreAgentsInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData,
        QueryKey,
        GetV2ListStoreAgentsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListStoreAgentsInfiniteQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV2ListStoreAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListStoreAgentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>
  > = ({ signal }) =>
    getV2ListStoreAgents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListStoreAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListStoreAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListStoreAgents>>
>;
export type GetV2ListStoreAgentsQueryError = HTTPValidationError;

export function useGetV2ListStoreAgents<
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetV2ListStoreAgentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreAgents<
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreAgents<
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List store agents
 */

export function useGetV2ListStoreAgents<
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListStoreAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List store agents
 */
export const prefetchGetV2ListStoreAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListStoreAgents>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListStoreAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListStoreAgentsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetSpecificAgentResponse200 = {
  data: StoreAgentDetails;
  status: 200;
};

export type getV2GetSpecificAgentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetSpecificAgentResponseSuccess =
  getV2GetSpecificAgentResponse200 & {
    headers: Headers;
  };
export type getV2GetSpecificAgentResponseError =
  getV2GetSpecificAgentResponse422 & {
    headers: Headers;
  };

export type getV2GetSpecificAgentResponse =
  | getV2GetSpecificAgentResponseSuccess
  | getV2GetSpecificAgentResponseError;

export const getGetV2GetSpecificAgentUrl = (
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/agents/${username}/${agentName}?${stringifiedParams}`
    : `/api/store/agents/${username}/${agentName}`;
};

/**
 * Get details of a marketplace agent
 * @summary Get specific agent
 */
export const getV2GetSpecificAgent = async (
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: RequestInit,
): Promise<getV2GetSpecificAgentResponse> => {
  return customMutator<getV2GetSpecificAgentResponse>(
    getGetV2GetSpecificAgentUrl(username, agentName, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetSpecificAgentQueryKey = (
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
) => {
  return [
    `/api/store/agents/${username}/${agentName}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetSpecificAgentQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetSpecificAgentQueryKey(username, agentName, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetSpecificAgent>>
  > = ({ signal }) =>
    getV2GetSpecificAgent(username, agentName, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      username !== null &&
      username !== undefined &&
      agentName !== null &&
      agentName !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetSpecificAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetSpecificAgent>>
>;
export type GetV2GetSpecificAgentQueryError = HTTPValidationError;

export function useGetV2GetSpecificAgent<
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  username: string,
  agentName: string,
  params: undefined | GetV2GetSpecificAgentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSpecificAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSpecificAgent<
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
          TError,
          Awaited<ReturnType<typeof getV2GetSpecificAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetSpecificAgent<
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get specific agent
 */

export function useGetV2GetSpecificAgent<
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetSpecificAgentQueryOptions(
    username,
    agentName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get specific agent
 */
export const prefetchGetV2GetSpecificAgentQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  username: string,
  agentName: string,
  params?: GetV2GetSpecificAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetSpecificAgent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetSpecificAgentQueryOptions(
    username,
    agentName,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CreateAgentReviewResponse200 = {
  data: StoreReview;
  status: 200;
};

export type postV2CreateAgentReviewResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CreateAgentReviewResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CreateAgentReviewResponseSuccess =
  postV2CreateAgentReviewResponse200 & {
    headers: Headers;
  };
export type postV2CreateAgentReviewResponseError = (
  | postV2CreateAgentReviewResponse401
  | postV2CreateAgentReviewResponse422
) & {
  headers: Headers;
};

export type postV2CreateAgentReviewResponse =
  | postV2CreateAgentReviewResponseSuccess
  | postV2CreateAgentReviewResponseError;

export const getPostV2CreateAgentReviewUrl = (
  username: string,
  agentName: string,
) => {
  return `/api/store/agents/${username}/${agentName}/review`;
};

/**
 * Post a user review on a marketplace agent listing
 * @summary Create agent review
 */
export const postV2CreateAgentReview = async (
  username: string,
  agentName: string,
  storeReviewCreate: StoreReviewCreate,
  options?: RequestInit,
): Promise<postV2CreateAgentReviewResponse> => {
  return customMutator<postV2CreateAgentReviewResponse>(
    getPostV2CreateAgentReviewUrl(username, agentName),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(storeReviewCreate),
    },
  );
};

export const getPostV2CreateAgentReviewMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CreateAgentReview>>,
    TError,
    { username: string; agentName: string; data: StoreReviewCreate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CreateAgentReview>>,
  TError,
  { username: string; agentName: string; data: StoreReviewCreate },
  TContext
> => {
  const mutationKey = ["postV2CreateAgentReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CreateAgentReview>>,
    { username: string; agentName: string; data: StoreReviewCreate }
  > = (props) => {
    const { username, agentName, data } = props ?? {};

    return postV2CreateAgentReview(username, agentName, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CreateAgentReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CreateAgentReview>>
>;
export type PostV2CreateAgentReviewMutationBody = StoreReviewCreate;
export type PostV2CreateAgentReviewMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create agent review
 */
export const usePostV2CreateAgentReview = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CreateAgentReview>>,
      TError,
      { username: string; agentName: string; data: StoreReviewCreate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CreateAgentReview>>,
  TError,
  { username: string; agentName: string; data: StoreReviewCreate },
  TContext
> => {
  return useMutation(
    getPostV2CreateAgentReviewMutationOptions(options),
    queryClient,
  );
};
export type getV2ListStoreCategoriesResponse200 = {
  data: StoreCategoryInfo[];
  status: 200;
};

export type getV2ListStoreCategoriesResponseSuccess =
  getV2ListStoreCategoriesResponse200 & {
    headers: Headers;
  };
export type getV2ListStoreCategoriesResponse =
  getV2ListStoreCategoriesResponseSuccess;

export const getGetV2ListStoreCategoriesUrl = () => {
  return `/api/store/categories`;
};

/**
 * The canonical categories a listing can be filed under.
 * @summary List store categories
 */
export const getV2ListStoreCategories = async (
  options?: RequestInit,
): Promise<getV2ListStoreCategoriesResponse> => {
  return customMutator<getV2ListStoreCategoriesResponse>(
    getGetV2ListStoreCategoriesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListStoreCategoriesQueryKey = () => {
  return [`/api/store/categories`] as const;
};

export const getGetV2ListStoreCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListStoreCategories>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListStoreCategoriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListStoreCategories>>
  > = ({ signal }) => getV2ListStoreCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListStoreCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListStoreCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListStoreCategories>>
>;
export type GetV2ListStoreCategoriesQueryError = unknown;

export function useGetV2ListStoreCategories<
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreCategories>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreCategories<
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreCategories>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreCategories<
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List store categories
 */

export function useGetV2ListStoreCategories<
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListStoreCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List store categories
 */
export const prefetchGetV2ListStoreCategoriesQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListStoreCategories>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListStoreCategoriesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListStoreCreatorsResponse200 = {
  data: CreatorsResponse;
  status: 200;
};

export type getV2ListStoreCreatorsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListStoreCreatorsResponseSuccess =
  getV2ListStoreCreatorsResponse200 & {
    headers: Headers;
  };
export type getV2ListStoreCreatorsResponseError =
  getV2ListStoreCreatorsResponse422 & {
    headers: Headers;
  };

export type getV2ListStoreCreatorsResponse =
  | getV2ListStoreCreatorsResponseSuccess
  | getV2ListStoreCreatorsResponseError;

export const getGetV2ListStoreCreatorsUrl = (
  params?: GetV2ListStoreCreatorsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/creators?${stringifiedParams}`
    : `/api/store/creators`;
};

/**
 * List or search marketplace creators
 * @summary List store creators
 */
export const getV2ListStoreCreators = async (
  params?: GetV2ListStoreCreatorsParams,
  options?: RequestInit,
): Promise<getV2ListStoreCreatorsResponse> => {
  return customMutator<getV2ListStoreCreatorsResponse>(
    getGetV2ListStoreCreatorsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListStoreCreatorsQueryKey = (
  params?: GetV2ListStoreCreatorsParams,
) => {
  return [`/api/store/creators`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListStoreCreatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListStoreCreatorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListStoreCreators>>
  > = ({ signal }) =>
    getV2ListStoreCreators(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListStoreCreators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListStoreCreatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListStoreCreators>>
>;
export type GetV2ListStoreCreatorsQueryError = HTTPValidationError;

export function useGetV2ListStoreCreators<
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetV2ListStoreCreatorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreCreators>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreCreators<
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListStoreCreators>>,
          TError,
          Awaited<ReturnType<typeof getV2ListStoreCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListStoreCreators<
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List store creators
 */

export function useGetV2ListStoreCreators<
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListStoreCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListStoreCreatorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List store creators
 */
export const prefetchGetV2ListStoreCreatorsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListStoreCreators>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListStoreCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListStoreCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListStoreCreatorsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetCreatorDetailsResponse200 = {
  data: CreatorDetails;
  status: 200;
};

export type getV2GetCreatorDetailsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetCreatorDetailsResponseSuccess =
  getV2GetCreatorDetailsResponse200 & {
    headers: Headers;
  };
export type getV2GetCreatorDetailsResponseError =
  getV2GetCreatorDetailsResponse422 & {
    headers: Headers;
  };

export type getV2GetCreatorDetailsResponse =
  | getV2GetCreatorDetailsResponseSuccess
  | getV2GetCreatorDetailsResponseError;

export const getGetV2GetCreatorDetailsUrl = (username: string) => {
  return `/api/store/creators/${username}`;
};

/**
 * Get details on a marketplace creator
 * @summary Get creator details
 */
export const getV2GetCreatorDetails = async (
  username: string,
  options?: RequestInit,
): Promise<getV2GetCreatorDetailsResponse> => {
  return customMutator<getV2GetCreatorDetailsResponse>(
    getGetV2GetCreatorDetailsUrl(username),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetCreatorDetailsQueryKey = (username: string) => {
  return [`/api/store/creators/${username}`] as const;
};

export const getGetV2GetCreatorDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  username: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetCreatorDetailsQueryKey(username);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetCreatorDetails>>
  > = ({ signal }) =>
    getV2GetCreatorDetails(username, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: username !== null && username !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetCreatorDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetCreatorDetails>>
>;
export type GetV2GetCreatorDetailsQueryError = HTTPValidationError;

export function useGetV2GetCreatorDetails<
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  username: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCreatorDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCreatorDetails<
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  username: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
          TError,
          Awaited<ReturnType<typeof getV2GetCreatorDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetCreatorDetails<
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  username: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get creator details
 */

export function useGetV2GetCreatorDetails<
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  username: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetCreatorDetailsQueryOptions(username, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get creator details
 */
export const prefetchGetV2GetCreatorDetailsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  username: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetCreatorDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetCreatorDetailsQueryOptions(username, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAgentByVersionResponse200 = {
  data: StoreAgentDetails;
  status: 200;
};

export type getV2GetAgentByVersionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetAgentByVersionResponseSuccess =
  getV2GetAgentByVersionResponse200 & {
    headers: Headers;
  };
export type getV2GetAgentByVersionResponseError =
  getV2GetAgentByVersionResponse422 & {
    headers: Headers;
  };

export type getV2GetAgentByVersionResponse =
  | getV2GetAgentByVersionResponseSuccess
  | getV2GetAgentByVersionResponseError;

export const getGetV2GetAgentByVersionUrl = (storeListingVersionId: string) => {
  return `/api/store/listings/versions/${storeListingVersionId}`;
};

/**
 * @summary Get agent by version
 */
export const getV2GetAgentByVersion = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2GetAgentByVersionResponse> => {
  return customMutator<getV2GetAgentByVersionResponse>(
    getGetV2GetAgentByVersionUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAgentByVersionQueryKey = (
  storeListingVersionId: string,
) => {
  return [`/api/store/listings/versions/${storeListingVersionId}`] as const;
};

export const getGetV2GetAgentByVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetAgentByVersionQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAgentByVersion>>
  > = ({ signal }) =>
    getV2GetAgentByVersion(storeListingVersionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAgentByVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAgentByVersion>>
>;
export type GetV2GetAgentByVersionQueryError = HTTPValidationError;

export function useGetV2GetAgentByVersion<
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentByVersion<
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentByVersion<
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get agent by version
 */

export function useGetV2GetAgentByVersion<
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAgentByVersionQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get agent by version
 */
export const prefetchGetV2GetAgentByVersionQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentByVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAgentByVersionQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetAgentGraphResponse200 = {
  data: GraphModelWithoutNodes;
  status: 200;
};

export type getV2GetAgentGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetAgentGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetAgentGraphResponseSuccess =
  getV2GetAgentGraphResponse200 & {
    headers: Headers;
  };
export type getV2GetAgentGraphResponseError = (
  | getV2GetAgentGraphResponse401
  | getV2GetAgentGraphResponse422
) & {
  headers: Headers;
};

export type getV2GetAgentGraphResponse =
  | getV2GetAgentGraphResponseSuccess
  | getV2GetAgentGraphResponseError;

export const getGetV2GetAgentGraphUrl = (storeListingVersionId: string) => {
  return `/api/store/listings/versions/${storeListingVersionId}/graph`;
};

/**
 * Get outline of graph belonging to a specific marketplace listing version
 * @summary Get agent graph
 */
export const getV2GetAgentGraph = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2GetAgentGraphResponse> => {
  return customMutator<getV2GetAgentGraphResponse>(
    getGetV2GetAgentGraphUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetAgentGraphQueryKey = (
  storeListingVersionId: string,
) => {
  return [
    `/api/store/listings/versions/${storeListingVersionId}/graph`,
  ] as const;
};

export const getGetV2GetAgentGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetAgentGraphQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetAgentGraph>>
  > = ({ signal }) =>
    getV2GetAgentGraph(storeListingVersionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetAgentGraph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetAgentGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetAgentGraph>>
>;
export type GetV2GetAgentGraphQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetAgentGraph<
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentGraph<
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetAgentGraph>>,
          TError,
          Awaited<ReturnType<typeof getV2GetAgentGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetAgentGraph<
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get agent graph
 */

export function useGetV2GetAgentGraph<
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetAgentGraphQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get agent graph
 */
export const prefetchGetV2GetAgentGraphQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetAgentGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetAgentGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetAgentGraphQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2DownloadAgentFileResponse200 = {
  data: unknown;
  status: 200;
};

export type getV2DownloadAgentFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2DownloadAgentFileResponseSuccess =
  getV2DownloadAgentFileResponse200 & {
    headers: Headers;
  };
export type getV2DownloadAgentFileResponseError =
  getV2DownloadAgentFileResponse422 & {
    headers: Headers;
  };

export type getV2DownloadAgentFileResponse =
  | getV2DownloadAgentFileResponseSuccess
  | getV2DownloadAgentFileResponseError;

export const getGetV2DownloadAgentFileUrl = (storeListingVersionId: string) => {
  return `/api/store/listings/versions/${storeListingVersionId}/graph/download`;
};

/**
 * Download agent graph file for a specific marketplace listing version
 * @summary Download agent file
 */
export const getV2DownloadAgentFile = async (
  storeListingVersionId: string,
  options?: RequestInit,
): Promise<getV2DownloadAgentFileResponse> => {
  return customMutator<getV2DownloadAgentFileResponse>(
    getGetV2DownloadAgentFileUrl(storeListingVersionId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2DownloadAgentFileQueryKey = (
  storeListingVersionId: string,
) => {
  return [
    `/api/store/listings/versions/${storeListingVersionId}/graph/download`,
  ] as const;
};

export const getGetV2DownloadAgentFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2DownloadAgentFileQueryKey(storeListingVersionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2DownloadAgentFile>>
  > = ({ signal }) =>
    getV2DownloadAgentFile(storeListingVersionId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      storeListingVersionId !== null && storeListingVersionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2DownloadAgentFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2DownloadAgentFile>>
>;
export type GetV2DownloadAgentFileQueryError = HTTPValidationError;

export function useGetV2DownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
          TError,
          Awaited<ReturnType<typeof getV2DownloadAgentFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2DownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
          TError,
          Awaited<ReturnType<typeof getV2DownloadAgentFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2DownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download agent file
 */

export function useGetV2DownloadAgentFile<
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2DownloadAgentFileQueryOptions(
    storeListingVersionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download agent file
 */
export const prefetchGetV2DownloadAgentFileQuery = async <
  TData = Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  storeListingVersionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2DownloadAgentFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2DownloadAgentFileQueryOptions(
    storeListingVersionId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetStoredMarketplaceMediaResponse200 = {
  data: Blob;
  status: 200;
};

export type getV2GetStoredMarketplaceMediaResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetStoredMarketplaceMediaResponseSuccess =
  getV2GetStoredMarketplaceMediaResponse200 & {
    headers: Headers;
  };
export type getV2GetStoredMarketplaceMediaResponseError =
  getV2GetStoredMarketplaceMediaResponse422 & {
    headers: Headers;
  };

export type getV2GetStoredMarketplaceMediaResponse =
  | getV2GetStoredMarketplaceMediaResponseSuccess
  | getV2GetStoredMarketplaceMediaResponseError;

export const getGetV2GetStoredMarketplaceMediaUrl = (
  userId: string,
  mediaType: string,
  filename: string,
) => {
  return `/api/store/media/${userId}/${mediaType}/${filename}`;
};

/**
 * @summary Get stored marketplace media
 */
export const getV2GetStoredMarketplaceMedia = async (
  userId: string,
  mediaType: string,
  filename: string,
  options?: RequestInit,
): Promise<getV2GetStoredMarketplaceMediaResponse> => {
  return customMutator<getV2GetStoredMarketplaceMediaResponse>(
    getGetV2GetStoredMarketplaceMediaUrl(userId, mediaType, filename),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetStoredMarketplaceMediaQueryKey = (
  userId: string,
  mediaType: string,
  filename: string,
) => {
  return [`/api/store/media/${userId}/${mediaType}/${filename}`] as const;
};

export const getGetV2GetStoredMarketplaceMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  userId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2GetStoredMarketplaceMediaQueryKey(userId, mediaType, filename);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>
  > = ({ signal }) =>
    getV2GetStoredMarketplaceMedia(userId, mediaType, filename, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      mediaType !== null &&
      mediaType !== undefined &&
      filename !== null &&
      filename !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetStoredMarketplaceMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>
>;
export type GetV2GetStoredMarketplaceMediaQueryError = HTTPValidationError;

export function useGetV2GetStoredMarketplaceMedia<
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  userId: string,
  mediaType: string,
  filename: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
          TError,
          Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetStoredMarketplaceMedia<
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  userId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
          TError,
          Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetStoredMarketplaceMedia<
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  userId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get stored marketplace media
 */

export function useGetV2GetStoredMarketplaceMedia<
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  userId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetStoredMarketplaceMediaQueryOptions(
    userId,
    mediaType,
    filename,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get stored marketplace media
 */
export const prefetchGetV2GetStoredMarketplaceMediaQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  userId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetStoredMarketplaceMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetStoredMarketplaceMediaQueryOptions(
    userId,
    mediaType,
    filename,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetMyAgentsResponse200 = {
  data: MyUnpublishedAgentsResponse;
  status: 200;
};

export type getV2GetMyAgentsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetMyAgentsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetMyAgentsResponseSuccess = getV2GetMyAgentsResponse200 & {
  headers: Headers;
};
export type getV2GetMyAgentsResponseError = (
  | getV2GetMyAgentsResponse401
  | getV2GetMyAgentsResponse422
) & {
  headers: Headers;
};

export type getV2GetMyAgentsResponse =
  | getV2GetMyAgentsResponseSuccess
  | getV2GetMyAgentsResponseError;

export const getGetV2GetMyAgentsUrl = (params?: GetV2GetMyAgentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/my-unpublished-agents?${stringifiedParams}`
    : `/api/store/my-unpublished-agents`;
};

/**
 * List the authenticated user's unpublished agents
 * @summary Get my agents
 */
export const getV2GetMyAgents = async (
  params?: GetV2GetMyAgentsParams,
  options?: RequestInit,
): Promise<getV2GetMyAgentsResponse> => {
  return customMutator<getV2GetMyAgentsResponse>(
    getGetV2GetMyAgentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetMyAgentsQueryKey = (
  params?: GetV2GetMyAgentsParams,
) => {
  return [
    `/api/store/my-unpublished-agents`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2GetMyAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetMyAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetMyAgentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetMyAgents>>
  > = ({ signal }) => getV2GetMyAgents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetMyAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetMyAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetMyAgents>>
>;
export type GetV2GetMyAgentsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2GetMyAgents<
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2GetMyAgentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMyAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMyAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMyAgents<
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetMyAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMyAgents>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMyAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMyAgents<
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetMyAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get my agents
 */

export function useGetV2GetMyAgents<
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2GetMyAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetMyAgentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get my agents
 */
export const prefetchGetV2GetMyAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetMyAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2GetMyAgentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMyAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetMyAgentsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2GetUserProfileResponse200 = {
  data: ProfileDetails;
  status: 200;
};

export type getV2GetUserProfileResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2GetUserProfileResponseSuccess =
  getV2GetUserProfileResponse200 & {
    headers: Headers;
  };
export type getV2GetUserProfileResponseError =
  getV2GetUserProfileResponse401 & {
    headers: Headers;
  };

export type getV2GetUserProfileResponse =
  | getV2GetUserProfileResponseSuccess
  | getV2GetUserProfileResponseError;

export const getGetV2GetUserProfileUrl = () => {
  return `/api/store/profile`;
};

/**
 * Get the profile details for the authenticated user, creating their
 * default profile if account setup hasn't yet.
 * @summary Get user profile
 */
export const getV2GetUserProfile = async (
  options?: RequestInit,
): Promise<getV2GetUserProfileResponse> => {
  return customMutator<getV2GetUserProfileResponse>(
    getGetV2GetUserProfileUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetUserProfileQueryKey = () => {
  return [`/api/store/profile`] as const;
};

export const getGetV2GetUserProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2GetUserProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV2GetUserProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetUserProfile>>
  > = ({ signal }) => getV2GetUserProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetUserProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetUserProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetUserProfile>>
>;
export type GetV2GetUserProfileQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2GetUserProfile<
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserProfile<
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getV2GetUserProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetUserProfile<
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user profile
 */

export function useGetV2GetUserProfile<
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetUserProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user profile
 */
export const prefetchGetV2GetUserProfileQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetUserProfile>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetUserProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetUserProfileQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2UpdateUserProfileResponse200 = {
  data: ProfileDetails;
  status: 200;
};

export type postV2UpdateUserProfileResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2UpdateUserProfileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2UpdateUserProfileResponseSuccess =
  postV2UpdateUserProfileResponse200 & {
    headers: Headers;
  };
export type postV2UpdateUserProfileResponseError = (
  | postV2UpdateUserProfileResponse401
  | postV2UpdateUserProfileResponse422
) & {
  headers: Headers;
};

export type postV2UpdateUserProfileResponse =
  | postV2UpdateUserProfileResponseSuccess
  | postV2UpdateUserProfileResponseError;

export const getPostV2UpdateUserProfileUrl = () => {
  return `/api/store/profile`;
};

/**
 * Update the store profile for the authenticated user.
 * @summary Update user profile
 */
export const postV2UpdateUserProfile = async (
  profileUpdateRequest: ProfileUpdateRequest,
  options?: RequestInit,
): Promise<postV2UpdateUserProfileResponse> => {
  return customMutator<postV2UpdateUserProfileResponse>(
    getPostV2UpdateUserProfileUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(profileUpdateRequest),
    },
  );
};

export const getPostV2UpdateUserProfileMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2UpdateUserProfile>>,
    TError,
    { data: ProfileUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2UpdateUserProfile>>,
  TError,
  { data: ProfileUpdateRequest },
  TContext
> => {
  const mutationKey = ["postV2UpdateUserProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2UpdateUserProfile>>,
    { data: ProfileUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2UpdateUserProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2UpdateUserProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2UpdateUserProfile>>
>;
export type PostV2UpdateUserProfileMutationBody = ProfileUpdateRequest;
export type PostV2UpdateUserProfileMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update user profile
 */
export const usePostV2UpdateUserProfile = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2UpdateUserProfile>>,
      TError,
      { data: ProfileUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2UpdateUserProfile>>,
  TError,
  { data: ProfileUpdateRequest },
  TContext
> => {
  return useMutation(
    getPostV2UpdateUserProfileMutationOptions(options),
    queryClient,
  );
};
export type getV2UnifiedSearchAcrossAllContentTypesResponse200 = {
  data: UnifiedSearchResponse;
  status: 200;
};

export type getV2UnifiedSearchAcrossAllContentTypesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2UnifiedSearchAcrossAllContentTypesResponseSuccess =
  getV2UnifiedSearchAcrossAllContentTypesResponse200 & {
    headers: Headers;
  };
export type getV2UnifiedSearchAcrossAllContentTypesResponseError =
  getV2UnifiedSearchAcrossAllContentTypesResponse422 & {
    headers: Headers;
  };

export type getV2UnifiedSearchAcrossAllContentTypesResponse =
  | getV2UnifiedSearchAcrossAllContentTypesResponseSuccess
  | getV2UnifiedSearchAcrossAllContentTypesResponseError;

export const getGetV2UnifiedSearchAcrossAllContentTypesUrl = (
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["content_types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/search?${stringifiedParams}`
    : `/api/store/search`;
};

/**
 * Search across all content types (marketplace agents, blocks, documentation)
 * using hybrid search.
 *
 * Combines semantic (embedding-based) and lexical (text-based) search for best results.
 * @summary Unified search across all content types
 */
export const getV2UnifiedSearchAcrossAllContentTypes = async (
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: RequestInit,
): Promise<getV2UnifiedSearchAcrossAllContentTypesResponse> => {
  return customMutator<getV2UnifiedSearchAcrossAllContentTypesResponse>(
    getGetV2UnifiedSearchAcrossAllContentTypesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2UnifiedSearchAcrossAllContentTypesQueryKey = (
  params?: GetV2UnifiedSearchAcrossAllContentTypesParams,
) => {
  return [`/api/store/search`, ...(params ? [params] : [])] as const;
};

export const getGetV2UnifiedSearchAcrossAllContentTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2UnifiedSearchAcrossAllContentTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>
  > = ({ signal }) =>
    getV2UnifiedSearchAcrossAllContentTypes(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2UnifiedSearchAcrossAllContentTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>
>;
export type GetV2UnifiedSearchAcrossAllContentTypesQueryError =
  HTTPValidationError;

export function useGetV2UnifiedSearchAcrossAllContentTypes<
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
          TError,
          Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2UnifiedSearchAcrossAllContentTypes<
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
          TError,
          Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2UnifiedSearchAcrossAllContentTypes<
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Unified search across all content types
 */

export function useGetV2UnifiedSearchAcrossAllContentTypes<
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2UnifiedSearchAcrossAllContentTypesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Unified search across all content types
 */
export const prefetchGetV2UnifiedSearchAcrossAllContentTypesQuery = async <
  TData = Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params: GetV2UnifiedSearchAcrossAllContentTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2UnifiedSearchAcrossAllContentTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2UnifiedSearchAcrossAllContentTypesQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListMarketplaceSkillsResponse200 = {
  data: MarketplaceSkillsResponse;
  status: 200;
};

export type getV2ListMarketplaceSkillsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListMarketplaceSkillsResponseSuccess =
  getV2ListMarketplaceSkillsResponse200 & {
    headers: Headers;
  };
export type getV2ListMarketplaceSkillsResponseError =
  getV2ListMarketplaceSkillsResponse422 & {
    headers: Headers;
  };

export type getV2ListMarketplaceSkillsResponse =
  | getV2ListMarketplaceSkillsResponseSuccess
  | getV2ListMarketplaceSkillsResponseError;

export const getGetV2ListMarketplaceSkillsUrl = (
  params?: GetV2ListMarketplaceSkillsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/skills?${stringifiedParams}`
    : `/api/store/skills`;
};

/**
 * Approved skill listings, most recently updated first.
 * @summary List marketplace skills
 */
export const getV2ListMarketplaceSkills = async (
  params?: GetV2ListMarketplaceSkillsParams,
  options?: RequestInit,
): Promise<getV2ListMarketplaceSkillsResponse> => {
  return customMutator<getV2ListMarketplaceSkillsResponse>(
    getGetV2ListMarketplaceSkillsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListMarketplaceSkillsInfiniteQueryKey = (
  params?: GetV2ListMarketplaceSkillsParams,
) => {
  return [`/api/store/skills`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListMarketplaceSkillsQueryKey = (
  params?: GetV2ListMarketplaceSkillsParams,
) => {
  return [`/api/store/skills`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListMarketplaceSkillsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    GetV2ListMarketplaceSkillsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ListMarketplaceSkillsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    QueryKey,
    GetV2ListMarketplaceSkillsParams["page"]
  > = ({ signal, pageParam }) =>
    getV2ListMarketplaceSkills(
      { ...params, page: pageParam ?? params?.["page"] },
      { signal, ...requestOptions },
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    TError,
    TData,
    QueryKey,
    GetV2ListMarketplaceSkillsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListMarketplaceSkillsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>
>;
export type GetV2ListMarketplaceSkillsInfiniteQueryError = HTTPValidationError;

export function useGetV2ListMarketplaceSkillsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    GetV2ListMarketplaceSkillsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params: undefined | GetV2ListMarketplaceSkillsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMarketplaceSkillsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    GetV2ListMarketplaceSkillsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          QueryKey
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMarketplaceSkillsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    GetV2ListMarketplaceSkillsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List marketplace skills
 */

export function useGetV2ListMarketplaceSkillsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    GetV2ListMarketplaceSkillsParams["page"]
  >,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListMarketplaceSkillsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List marketplace skills
 */
export const prefetchGetV2ListMarketplaceSkillsInfiniteQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData,
        QueryKey,
        GetV2ListMarketplaceSkillsParams["page"]
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListMarketplaceSkillsInfiniteQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getGetV2ListMarketplaceSkillsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListMarketplaceSkillsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>
  > = ({ signal }) =>
    getV2ListMarketplaceSkills(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListMarketplaceSkillsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>
>;
export type GetV2ListMarketplaceSkillsQueryError = HTTPValidationError;

export function useGetV2ListMarketplaceSkills<
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetV2ListMarketplaceSkillsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMarketplaceSkills<
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMarketplaceSkills<
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List marketplace skills
 */

export function useGetV2ListMarketplaceSkills<
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListMarketplaceSkillsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List marketplace skills
 */
export const prefetchGetV2ListMarketplaceSkillsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
  TError = HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListMarketplaceSkillsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMarketplaceSkills>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListMarketplaceSkillsQueryOptions(
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ListMySkillSubmissionsResponse200 = {
  data: SkillSubmission[];
  status: 200;
};

export type getV2ListMySkillSubmissionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListMySkillSubmissionsResponseSuccess =
  getV2ListMySkillSubmissionsResponse200 & {
    headers: Headers;
  };
export type getV2ListMySkillSubmissionsResponseError =
  getV2ListMySkillSubmissionsResponse401 & {
    headers: Headers;
  };

export type getV2ListMySkillSubmissionsResponse =
  | getV2ListMySkillSubmissionsResponseSuccess
  | getV2ListMySkillSubmissionsResponseError;

export const getGetV2ListMySkillSubmissionsUrl = () => {
  return `/api/store/skills/submissions`;
};

/**
 * Every version the caller has submitted, newest first per listing.
 * @summary List my skill submissions
 */
export const getV2ListMySkillSubmissions = async (
  options?: RequestInit,
): Promise<getV2ListMySkillSubmissionsResponse> => {
  return customMutator<getV2ListMySkillSubmissionsResponse>(
    getGetV2ListMySkillSubmissionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListMySkillSubmissionsQueryKey = () => {
  return [`/api/store/skills/submissions`] as const;
};

export const getGetV2ListMySkillSubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListMySkillSubmissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>
  > = ({ signal }) =>
    getV2ListMySkillSubmissions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListMySkillSubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>
>;
export type GetV2ListMySkillSubmissionsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV2ListMySkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMySkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMySkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List my skill submissions
 */

export function useGetV2ListMySkillSubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListMySkillSubmissionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List my skill submissions
 */
export const prefetchGetV2ListMySkillSubmissionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySkillSubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListMySkillSubmissionsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2PublishSkillToMarketplaceResponse201 = {
  data: SkillSubmission;
  status: 201;
};

export type postV2PublishSkillToMarketplaceResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2PublishSkillToMarketplaceResponse404 = {
  data: void;
  status: 404;
};

export type postV2PublishSkillToMarketplaceResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2PublishSkillToMarketplaceResponse428 = {
  data: void;
  status: 428;
};

export type postV2PublishSkillToMarketplaceResponseSuccess =
  postV2PublishSkillToMarketplaceResponse201 & {
    headers: Headers;
  };
export type postV2PublishSkillToMarketplaceResponseError = (
  | postV2PublishSkillToMarketplaceResponse401
  | postV2PublishSkillToMarketplaceResponse404
  | postV2PublishSkillToMarketplaceResponse422
  | postV2PublishSkillToMarketplaceResponse428
) & {
  headers: Headers;
};

export type postV2PublishSkillToMarketplaceResponse =
  | postV2PublishSkillToMarketplaceResponseSuccess
  | postV2PublishSkillToMarketplaceResponseError;

export const getPostV2PublishSkillToMarketplaceUrl = () => {
  return `/api/store/skills/submissions`;
};

/**
 * Submit one of the caller's own library skills for marketplace review.
 * @summary Publish skill to marketplace
 */
export const postV2PublishSkillToMarketplace = async (
  skillSubmissionRequest: SkillSubmissionRequest,
  options?: RequestInit,
): Promise<postV2PublishSkillToMarketplaceResponse> => {
  return customMutator<postV2PublishSkillToMarketplaceResponse>(
    getPostV2PublishSkillToMarketplaceUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(skillSubmissionRequest),
    },
  );
};

export const getPostV2PublishSkillToMarketplaceMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>,
    TError,
    { data: SkillSubmissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>,
  TError,
  { data: SkillSubmissionRequest },
  TContext
> => {
  const mutationKey = ["postV2PublishSkillToMarketplace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>,
    { data: SkillSubmissionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2PublishSkillToMarketplace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2PublishSkillToMarketplaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>
>;
export type PostV2PublishSkillToMarketplaceMutationBody =
  SkillSubmissionRequest;
export type PostV2PublishSkillToMarketplaceMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Publish skill to marketplace
 */
export const usePostV2PublishSkillToMarketplace = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>,
      TError,
      { data: SkillSubmissionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2PublishSkillToMarketplace>>,
  TError,
  { data: SkillSubmissionRequest },
  TContext
> => {
  return useMutation(
    getPostV2PublishSkillToMarketplaceMutationOptions(options),
    queryClient,
  );
};
export type putV2EditSkillSubmissionResponse200 = {
  data: SkillSubmission;
  status: 200;
};

export type putV2EditSkillSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV2EditSkillSubmissionResponse404 = {
  data: void;
  status: 404;
};

export type putV2EditSkillSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV2EditSkillSubmissionResponse428 = {
  data: void;
  status: 428;
};

export type putV2EditSkillSubmissionResponseSuccess =
  putV2EditSkillSubmissionResponse200 & {
    headers: Headers;
  };
export type putV2EditSkillSubmissionResponseError = (
  | putV2EditSkillSubmissionResponse401
  | putV2EditSkillSubmissionResponse404
  | putV2EditSkillSubmissionResponse422
  | putV2EditSkillSubmissionResponse428
) & {
  headers: Headers;
};

export type putV2EditSkillSubmissionResponse =
  | putV2EditSkillSubmissionResponseSuccess
  | putV2EditSkillSubmissionResponseError;

export const getPutV2EditSkillSubmissionUrl = (
  skillListingVersionId: string,
) => {
  return `/api/store/skills/submissions/${skillListingVersionId}`;
};

/**
 * Update a pending submission and re-snapshot the library skill.
 * @summary Edit skill submission
 */
export const putV2EditSkillSubmission = async (
  skillListingVersionId: string,
  skillSubmissionRequest: SkillSubmissionRequest,
  options?: RequestInit,
): Promise<putV2EditSkillSubmissionResponse> => {
  return customMutator<putV2EditSkillSubmissionResponse>(
    getPutV2EditSkillSubmissionUrl(skillListingVersionId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(skillSubmissionRequest),
    },
  );
};

export const getPutV2EditSkillSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV2EditSkillSubmission>>,
    TError,
    { skillListingVersionId: string; data: SkillSubmissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV2EditSkillSubmission>>,
  TError,
  { skillListingVersionId: string; data: SkillSubmissionRequest },
  TContext
> => {
  const mutationKey = ["putV2EditSkillSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV2EditSkillSubmission>>,
    { skillListingVersionId: string; data: SkillSubmissionRequest }
  > = (props) => {
    const { skillListingVersionId, data } = props ?? {};

    return putV2EditSkillSubmission(
      skillListingVersionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV2EditSkillSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV2EditSkillSubmission>>
>;
export type PutV2EditSkillSubmissionMutationBody = SkillSubmissionRequest;
export type PutV2EditSkillSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Edit skill submission
 */
export const usePutV2EditSkillSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV2EditSkillSubmission>>,
      TError,
      { skillListingVersionId: string; data: SkillSubmissionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV2EditSkillSubmission>>,
  TError,
  { skillListingVersionId: string; data: SkillSubmissionRequest },
  TContext
> => {
  return useMutation(
    getPutV2EditSkillSubmissionMutationOptions(options),
    queryClient,
  );
};
export type getV2GetMarketplaceSkillResponse200 = {
  data: MarketplaceSkillDetails;
  status: 200;
};

export type getV2GetMarketplaceSkillResponse404 = {
  data: void;
  status: 404;
};

export type getV2GetMarketplaceSkillResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2GetMarketplaceSkillResponseSuccess =
  getV2GetMarketplaceSkillResponse200 & {
    headers: Headers;
  };
export type getV2GetMarketplaceSkillResponseError = (
  | getV2GetMarketplaceSkillResponse404
  | getV2GetMarketplaceSkillResponse422
) & {
  headers: Headers;
};

export type getV2GetMarketplaceSkillResponse =
  | getV2GetMarketplaceSkillResponseSuccess
  | getV2GetMarketplaceSkillResponseError;

export const getGetV2GetMarketplaceSkillUrl = (slug: string) => {
  return `/api/store/skills/${slug}`;
};

/**
 * One listing with the full SKILL.md body the install will copy.
 * @summary Get marketplace skill
 */
export const getV2GetMarketplaceSkill = async (
  slug: string,
  options?: RequestInit,
): Promise<getV2GetMarketplaceSkillResponse> => {
  return customMutator<getV2GetMarketplaceSkillResponse>(
    getGetV2GetMarketplaceSkillUrl(slug),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2GetMarketplaceSkillQueryKey = (slug: string) => {
  return [`/api/store/skills/${slug}`] as const;
};

export const getGetV2GetMarketplaceSkillQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2GetMarketplaceSkillQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>
  > = ({ signal }) =>
    getV2GetMarketplaceSkill(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2GetMarketplaceSkillQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>
>;
export type GetV2GetMarketplaceSkillQueryError = void | HTTPValidationError;

export function useGetV2GetMarketplaceSkill<
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMarketplaceSkill<
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
          TError,
          Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2GetMarketplaceSkill<
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get marketplace skill
 */

export function useGetV2GetMarketplaceSkill<
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2GetMarketplaceSkillQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get marketplace skill
 */
export const prefetchGetV2GetMarketplaceSkillQuery = async <
  TData = Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
  TError = void | HTTPValidationError,
>(
  queryClient: QueryClient,
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2GetMarketplaceSkill>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2GetMarketplaceSkillQueryOptions(slug, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getV2ReadMarketplaceSkillFileResponse200 = {
  data: string;
  status: 200;
};

export type getV2ReadMarketplaceSkillFileResponse404 = {
  data: void;
  status: 404;
};

export type getV2ReadMarketplaceSkillFileResponse413 = {
  data: void;
  status: 413;
};

export type getV2ReadMarketplaceSkillFileResponse415 = {
  data: void;
  status: 415;
};

export type getV2ReadMarketplaceSkillFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ReadMarketplaceSkillFileResponseSuccess =
  getV2ReadMarketplaceSkillFileResponse200 & {
    headers: Headers;
  };
export type getV2ReadMarketplaceSkillFileResponseError = (
  | getV2ReadMarketplaceSkillFileResponse404
  | getV2ReadMarketplaceSkillFileResponse413
  | getV2ReadMarketplaceSkillFileResponse415
  | getV2ReadMarketplaceSkillFileResponse422
) & {
  headers: Headers;
};

export type getV2ReadMarketplaceSkillFileResponse =
  | getV2ReadMarketplaceSkillFileResponseSuccess
  | getV2ReadMarketplaceSkillFileResponseError;

export const getGetV2ReadMarketplaceSkillFileUrl = (
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/skills/${slug}/files/${path}?${stringifiedParams}`
    : `/api/store/skills/${slug}/files/${path}`;
};

/**
 * One file's text, for reading a package before installing it.
 * @summary Read marketplace skill file
 */
export const getV2ReadMarketplaceSkillFile = async (
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: RequestInit,
): Promise<getV2ReadMarketplaceSkillFileResponse> => {
  return customMutator<getV2ReadMarketplaceSkillFileResponse>(
    getGetV2ReadMarketplaceSkillFileUrl(slug, path, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ReadMarketplaceSkillFileQueryKey = (
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
) => {
  return [
    `/api/store/skills/${slug}/files/${path}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV2ReadMarketplaceSkillFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ReadMarketplaceSkillFileQueryKey(slug, path, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>
  > = ({ signal }) =>
    getV2ReadMarketplaceSkillFile(slug, path, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      slug !== null &&
      slug !== undefined &&
      path !== null &&
      path !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ReadMarketplaceSkillFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>
>;
export type GetV2ReadMarketplaceSkillFileQueryError =
  void | HTTPValidationError;

export function useGetV2ReadMarketplaceSkillFile<
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  path: string,
  params: undefined | GetV2ReadMarketplaceSkillFileParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
          TError,
          Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ReadMarketplaceSkillFile<
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
          TError,
          Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ReadMarketplaceSkillFile<
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read marketplace skill file
 */

export function useGetV2ReadMarketplaceSkillFile<
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ReadMarketplaceSkillFileQueryOptions(
    slug,
    path,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Read marketplace skill file
 */
export const prefetchGetV2ReadMarketplaceSkillFileQuery = async <
  TData = Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
  TError = void | HTTPValidationError,
>(
  queryClient: QueryClient,
  slug: string,
  path: string,
  params?: GetV2ReadMarketplaceSkillFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadMarketplaceSkillFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ReadMarketplaceSkillFileQueryOptions(
    slug,
    path,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2InstallMarketplaceSkillResponse200 = {
  data: InstalledSkill;
  status: 200;
};

export type postV2InstallMarketplaceSkillResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2InstallMarketplaceSkillResponse404 = {
  data: void;
  status: 404;
};

export type postV2InstallMarketplaceSkillResponse409 = {
  data: void;
  status: 409;
};

export type postV2InstallMarketplaceSkillResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2InstallMarketplaceSkillResponseSuccess =
  postV2InstallMarketplaceSkillResponse200 & {
    headers: Headers;
  };
export type postV2InstallMarketplaceSkillResponseError = (
  | postV2InstallMarketplaceSkillResponse401
  | postV2InstallMarketplaceSkillResponse404
  | postV2InstallMarketplaceSkillResponse409
  | postV2InstallMarketplaceSkillResponse422
) & {
  headers: Headers;
};

export type postV2InstallMarketplaceSkillResponse =
  | postV2InstallMarketplaceSkillResponseSuccess
  | postV2InstallMarketplaceSkillResponseError;

export const getPostV2InstallMarketplaceSkillUrl = (
  slug: string,
  params?: PostV2InstallMarketplaceSkillParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/skills/${slug}/install?${stringifiedParams}`
    : `/api/store/skills/${slug}/install`;
};

/**
 * Copy the listing's skill into an expert's skills, or the caller's own.
 * @summary Install marketplace skill
 */
export const postV2InstallMarketplaceSkill = async (
  slug: string,
  params?: PostV2InstallMarketplaceSkillParams,
  options?: RequestInit,
): Promise<postV2InstallMarketplaceSkillResponse> => {
  return customMutator<postV2InstallMarketplaceSkillResponse>(
    getPostV2InstallMarketplaceSkillUrl(slug, params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2InstallMarketplaceSkillMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>,
    TError,
    { slug: string; params?: PostV2InstallMarketplaceSkillParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>,
  TError,
  { slug: string; params?: PostV2InstallMarketplaceSkillParams },
  TContext
> => {
  const mutationKey = ["postV2InstallMarketplaceSkill"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>,
    { slug: string; params?: PostV2InstallMarketplaceSkillParams }
  > = (props) => {
    const { slug, params } = props ?? {};

    return postV2InstallMarketplaceSkill(slug, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2InstallMarketplaceSkillMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>
>;

export type PostV2InstallMarketplaceSkillMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Install marketplace skill
 */
export const usePostV2InstallMarketplaceSkill = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>,
      TError,
      { slug: string; params?: PostV2InstallMarketplaceSkillParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2InstallMarketplaceSkill>>,
  TError,
  { slug: string; params?: PostV2InstallMarketplaceSkillParams },
  TContext
> => {
  return useMutation(
    getPostV2InstallMarketplaceSkillMutationOptions(options),
    queryClient,
  );
};
export type getV2ListMySubmissionsResponse200 = {
  data: StoreSubmissionsResponse;
  status: 200;
};

export type getV2ListMySubmissionsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ListMySubmissionsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ListMySubmissionsResponseSuccess =
  getV2ListMySubmissionsResponse200 & {
    headers: Headers;
  };
export type getV2ListMySubmissionsResponseError = (
  | getV2ListMySubmissionsResponse401
  | getV2ListMySubmissionsResponse422
) & {
  headers: Headers;
};

export type getV2ListMySubmissionsResponse =
  | getV2ListMySubmissionsResponseSuccess
  | getV2ListMySubmissionsResponseError;

export const getGetV2ListMySubmissionsUrl = (
  params?: GetV2ListMySubmissionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/submissions?${stringifiedParams}`
    : `/api/store/submissions`;
};

/**
 * List the authenticated user's marketplace listing submissions
 * @summary List my submissions
 */
export const getV2ListMySubmissions = async (
  params?: GetV2ListMySubmissionsParams,
  options?: RequestInit,
): Promise<getV2ListMySubmissionsResponse> => {
  return customMutator<getV2ListMySubmissionsResponse>(
    getGetV2ListMySubmissionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ListMySubmissionsQueryKey = (
  params?: GetV2ListMySubmissionsParams,
) => {
  return [`/api/store/submissions`, ...(params ? [params] : [])] as const;
};

export const getGetV2ListMySubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV2ListMySubmissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ListMySubmissions>>
  > = ({ signal }) =>
    getV2ListMySubmissions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ListMySubmissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ListMySubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ListMySubmissions>>
>;
export type GetV2ListMySubmissionsQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ListMySubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params: undefined | GetV2ListMySubmissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMySubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMySubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMySubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ListMySubmissions>>,
          TError,
          Awaited<ReturnType<typeof getV2ListMySubmissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ListMySubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List my submissions
 */

export function useGetV2ListMySubmissions<
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  params?: GetV2ListMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ListMySubmissionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List my submissions
 */
export const prefetchGetV2ListMySubmissionsQuery = async <
  TData = Awaited<ReturnType<typeof getV2ListMySubmissions>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  params?: GetV2ListMySubmissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ListMySubmissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ListMySubmissionsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV2CreateStoreSubmissionResponse200 = {
  data: StoreSubmission;
  status: 200;
};

export type postV2CreateStoreSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2CreateStoreSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2CreateStoreSubmissionResponseSuccess =
  postV2CreateStoreSubmissionResponse200 & {
    headers: Headers;
  };
export type postV2CreateStoreSubmissionResponseError = (
  | postV2CreateStoreSubmissionResponse401
  | postV2CreateStoreSubmissionResponse422
) & {
  headers: Headers;
};

export type postV2CreateStoreSubmissionResponse =
  | postV2CreateStoreSubmissionResponseSuccess
  | postV2CreateStoreSubmissionResponseError;

export const getPostV2CreateStoreSubmissionUrl = () => {
  return `/api/store/submissions`;
};

/**
 * Submit a new marketplace listing for review
 * @summary Create store submission
 */
export const postV2CreateStoreSubmission = async (
  storeSubmissionRequest: StoreSubmissionRequest,
  options?: RequestInit,
): Promise<postV2CreateStoreSubmissionResponse> => {
  return customMutator<postV2CreateStoreSubmissionResponse>(
    getPostV2CreateStoreSubmissionUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(storeSubmissionRequest),
    },
  );
};

export const getPostV2CreateStoreSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2CreateStoreSubmission>>,
    TError,
    { data: StoreSubmissionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2CreateStoreSubmission>>,
  TError,
  { data: StoreSubmissionRequest },
  TContext
> => {
  const mutationKey = ["postV2CreateStoreSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2CreateStoreSubmission>>,
    { data: StoreSubmissionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV2CreateStoreSubmission(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2CreateStoreSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2CreateStoreSubmission>>
>;
export type PostV2CreateStoreSubmissionMutationBody = StoreSubmissionRequest;
export type PostV2CreateStoreSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create store submission
 */
export const usePostV2CreateStoreSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2CreateStoreSubmission>>,
      TError,
      { data: StoreSubmissionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2CreateStoreSubmission>>,
  TError,
  { data: StoreSubmissionRequest },
  TContext
> => {
  return useMutation(
    getPostV2CreateStoreSubmissionMutationOptions(options),
    queryClient,
  );
};
export type postV2GenerateSubmissionImageResponse200 = {
  data: ImageURLResponse;
  status: 200;
};

export type postV2GenerateSubmissionImageResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2GenerateSubmissionImageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2GenerateSubmissionImageResponseSuccess =
  postV2GenerateSubmissionImageResponse200 & {
    headers: Headers;
  };
export type postV2GenerateSubmissionImageResponseError = (
  | postV2GenerateSubmissionImageResponse401
  | postV2GenerateSubmissionImageResponse422
) & {
  headers: Headers;
};

export type postV2GenerateSubmissionImageResponse =
  | postV2GenerateSubmissionImageResponseSuccess
  | postV2GenerateSubmissionImageResponseError;

export const getPostV2GenerateSubmissionImageUrl = (
  params: PostV2GenerateSubmissionImageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/submissions/generate_image?${stringifiedParams}`
    : `/api/store/submissions/generate_image`;
};

/**
 * Generate an image for a marketplace listing submission based on the properties
 * of a given graph.
 * @summary Generate submission image
 */
export const postV2GenerateSubmissionImage = async (
  params: PostV2GenerateSubmissionImageParams,
  options?: RequestInit,
): Promise<postV2GenerateSubmissionImageResponse> => {
  return customMutator<postV2GenerateSubmissionImageResponse>(
    getPostV2GenerateSubmissionImageUrl(params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV2GenerateSubmissionImageMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>,
    TError,
    { params: PostV2GenerateSubmissionImageParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>,
  TError,
  { params: PostV2GenerateSubmissionImageParams },
  TContext
> => {
  const mutationKey = ["postV2GenerateSubmissionImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>,
    { params: PostV2GenerateSubmissionImageParams }
  > = (props) => {
    const { params } = props ?? {};

    return postV2GenerateSubmissionImage(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2GenerateSubmissionImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>
>;

export type PostV2GenerateSubmissionImageMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Generate submission image
 */
export const usePostV2GenerateSubmissionImage = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>,
      TError,
      { params: PostV2GenerateSubmissionImageParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2GenerateSubmissionImage>>,
  TError,
  { params: PostV2GenerateSubmissionImageParams },
  TContext
> => {
  return useMutation(
    getPostV2GenerateSubmissionImageMutationOptions(options),
    queryClient,
  );
};
export type postV2UploadSubmissionMediaResponse200 = {
  data: string;
  status: 200;
};

export type postV2UploadSubmissionMediaResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV2UploadSubmissionMediaResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV2UploadSubmissionMediaResponseSuccess =
  postV2UploadSubmissionMediaResponse200 & {
    headers: Headers;
  };
export type postV2UploadSubmissionMediaResponseError = (
  | postV2UploadSubmissionMediaResponse401
  | postV2UploadSubmissionMediaResponse422
) & {
  headers: Headers;
};

export type postV2UploadSubmissionMediaResponse =
  | postV2UploadSubmissionMediaResponseSuccess
  | postV2UploadSubmissionMediaResponseError;

export const getPostV2UploadSubmissionMediaUrl = (
  params?: PostV2UploadSubmissionMediaParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/store/submissions/media?${stringifiedParams}`
    : `/api/store/submissions/media`;
};

/**
 * Upload media for a marketplace listing submission or Expert appearance.
 * @summary Upload submission media
 */
export const postV2UploadSubmissionMedia = async (
  bodyPostV2UploadSubmissionMedia: BodyPostV2UploadSubmissionMedia,
  params?: PostV2UploadSubmissionMediaParams,
  options?: RequestInit,
): Promise<postV2UploadSubmissionMediaResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyPostV2UploadSubmissionMedia.file);

  return customMutator<postV2UploadSubmissionMediaResponse>(
    getPostV2UploadSubmissionMediaUrl(params),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getPostV2UploadSubmissionMediaMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>,
    TError,
    {
      data: BodyPostV2UploadSubmissionMedia;
      params?: PostV2UploadSubmissionMediaParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>,
  TError,
  {
    data: BodyPostV2UploadSubmissionMedia;
    params?: PostV2UploadSubmissionMediaParams;
  },
  TContext
> => {
  const mutationKey = ["postV2UploadSubmissionMedia"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>,
    {
      data: BodyPostV2UploadSubmissionMedia;
      params?: PostV2UploadSubmissionMediaParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV2UploadSubmissionMedia(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV2UploadSubmissionMediaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>
>;
export type PostV2UploadSubmissionMediaMutationBody =
  BodyPostV2UploadSubmissionMedia;
export type PostV2UploadSubmissionMediaMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Upload submission media
 */
export const usePostV2UploadSubmissionMedia = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>,
      TError,
      {
        data: BodyPostV2UploadSubmissionMedia;
        params?: PostV2UploadSubmissionMediaParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV2UploadSubmissionMedia>>,
  TError,
  {
    data: BodyPostV2UploadSubmissionMedia;
    params?: PostV2UploadSubmissionMediaParams;
  },
  TContext
> => {
  return useMutation(
    getPostV2UploadSubmissionMediaMutationOptions(options),
    queryClient,
  );
};
export type getV2ReadPrivateSubmissionMediaResponse200 = {
  data: Blob;
  status: 200;
};

export type getV2ReadPrivateSubmissionMediaResponse206 = {
  data: Blob;
  status: 206;
};

export type getV2ReadPrivateSubmissionMediaResponse307 = {
  data: void;
  status: 307;
};

export type getV2ReadPrivateSubmissionMediaResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV2ReadPrivateSubmissionMediaResponse404 = {
  data: void;
  status: 404;
};

export type getV2ReadPrivateSubmissionMediaResponse416 = {
  data: void;
  status: 416;
};

export type getV2ReadPrivateSubmissionMediaResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV2ReadPrivateSubmissionMediaResponse503 = {
  data: void;
  status: 503;
};

export type getV2ReadPrivateSubmissionMediaResponseSuccess = (
  | getV2ReadPrivateSubmissionMediaResponse200
  | getV2ReadPrivateSubmissionMediaResponse206
) & {
  headers: Headers;
};
export type getV2ReadPrivateSubmissionMediaResponseError = (
  | getV2ReadPrivateSubmissionMediaResponse307
  | getV2ReadPrivateSubmissionMediaResponse401
  | getV2ReadPrivateSubmissionMediaResponse404
  | getV2ReadPrivateSubmissionMediaResponse416
  | getV2ReadPrivateSubmissionMediaResponse422
  | getV2ReadPrivateSubmissionMediaResponse503
) & {
  headers: Headers;
};

export type getV2ReadPrivateSubmissionMediaResponse =
  | getV2ReadPrivateSubmissionMediaResponseSuccess
  | getV2ReadPrivateSubmissionMediaResponseError;

export const getGetV2ReadPrivateSubmissionMediaUrl = (
  ownerUserId: string,
  mediaType: string,
  filename: string,
) => {
  return `/api/store/submissions/media/${ownerUserId}/${mediaType}/${filename}`;
};

/**
 * Serve a user's private media to them, to members of an organization they
 * share, and to admins. Anyone else gets a 404, as if it did not exist.
 * @summary Read private submission media
 */
export const getV2ReadPrivateSubmissionMedia = async (
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: RequestInit,
): Promise<getV2ReadPrivateSubmissionMediaResponse> => {
  return customMutator<getV2ReadPrivateSubmissionMediaResponse>(
    getGetV2ReadPrivateSubmissionMediaUrl(ownerUserId, mediaType, filename),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV2ReadPrivateSubmissionMediaQueryKey = (
  ownerUserId: string,
  mediaType: string,
  filename: string,
) => {
  return [
    `/api/store/submissions/media/${ownerUserId}/${mediaType}/${filename}`,
  ] as const;
};

export const getGetV2ReadPrivateSubmissionMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV2ReadPrivateSubmissionMediaQueryKey(
      ownerUserId,
      mediaType,
      filename,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>
  > = ({ signal }) =>
    getV2ReadPrivateSubmissionMedia(ownerUserId, mediaType, filename, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      ownerUserId !== null &&
      ownerUserId !== undefined &&
      mediaType !== null &&
      mediaType !== undefined &&
      filename !== null &&
      filename !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV2ReadPrivateSubmissionMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>
>;
export type GetV2ReadPrivateSubmissionMediaQueryError =
  | void
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV2ReadPrivateSubmissionMedia<
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
          TError,
          Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ReadPrivateSubmissionMedia<
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
          TError,
          Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV2ReadPrivateSubmissionMedia<
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read private submission media
 */

export function useGetV2ReadPrivateSubmissionMedia<
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV2ReadPrivateSubmissionMediaQueryOptions(
    ownerUserId,
    mediaType,
    filename,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Read private submission media
 */
export const prefetchGetV2ReadPrivateSubmissionMediaQuery = async <
  TData = Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
  TError = void | HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  ownerUserId: string,
  mediaType: string,
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV2ReadPrivateSubmissionMedia>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV2ReadPrivateSubmissionMediaQueryOptions(
    ownerUserId,
    mediaType,
    filename,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type putV2EditStoreSubmissionResponse200 = {
  data: StoreSubmission;
  status: 200;
};

export type putV2EditStoreSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type putV2EditStoreSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type putV2EditStoreSubmissionResponseSuccess =
  putV2EditStoreSubmissionResponse200 & {
    headers: Headers;
  };
export type putV2EditStoreSubmissionResponseError = (
  | putV2EditStoreSubmissionResponse401
  | putV2EditStoreSubmissionResponse422
) & {
  headers: Headers;
};

export type putV2EditStoreSubmissionResponse =
  | putV2EditStoreSubmissionResponseSuccess
  | putV2EditStoreSubmissionResponseError;

export const getPutV2EditStoreSubmissionUrl = (
  storeListingVersionId: string,
) => {
  return `/api/store/submissions/${storeListingVersionId}`;
};

/**
 * Update a pending marketplace listing submission
 * @summary Edit store submission
 */
export const putV2EditStoreSubmission = async (
  storeListingVersionId: string,
  storeSubmissionEditRequest: StoreSubmissionEditRequest,
  options?: RequestInit,
): Promise<putV2EditStoreSubmissionResponse> => {
  return customMutator<putV2EditStoreSubmissionResponse>(
    getPutV2EditStoreSubmissionUrl(storeListingVersionId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(storeSubmissionEditRequest),
    },
  );
};

export const getPutV2EditStoreSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putV2EditStoreSubmission>>,
    TError,
    { storeListingVersionId: string; data: StoreSubmissionEditRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putV2EditStoreSubmission>>,
  TError,
  { storeListingVersionId: string; data: StoreSubmissionEditRequest },
  TContext
> => {
  const mutationKey = ["putV2EditStoreSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putV2EditStoreSubmission>>,
    { storeListingVersionId: string; data: StoreSubmissionEditRequest }
  > = (props) => {
    const { storeListingVersionId, data } = props ?? {};

    return putV2EditStoreSubmission(
      storeListingVersionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutV2EditStoreSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putV2EditStoreSubmission>>
>;
export type PutV2EditStoreSubmissionMutationBody = StoreSubmissionEditRequest;
export type PutV2EditStoreSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Edit store submission
 */
export const usePutV2EditStoreSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putV2EditStoreSubmission>>,
      TError,
      { storeListingVersionId: string; data: StoreSubmissionEditRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putV2EditStoreSubmission>>,
  TError,
  { storeListingVersionId: string; data: StoreSubmissionEditRequest },
  TContext
> => {
  return useMutation(
    getPutV2EditStoreSubmissionMutationOptions(options),
    queryClient,
  );
};
export type deleteV2DeleteStoreSubmissionResponse200 = {
  data: boolean;
  status: 200;
};

export type deleteV2DeleteStoreSubmissionResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV2DeleteStoreSubmissionResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV2DeleteStoreSubmissionResponseSuccess =
  deleteV2DeleteStoreSubmissionResponse200 & {
    headers: Headers;
  };
export type deleteV2DeleteStoreSubmissionResponseError = (
  | deleteV2DeleteStoreSubmissionResponse401
  | deleteV2DeleteStoreSubmissionResponse422
) & {
  headers: Headers;
};

export type deleteV2DeleteStoreSubmissionResponse =
  | deleteV2DeleteStoreSubmissionResponseSuccess
  | deleteV2DeleteStoreSubmissionResponseError;

export const getDeleteV2DeleteStoreSubmissionUrl = (submissionId: string) => {
  return `/api/store/submissions/${submissionId}`;
};

/**
 * Delete a marketplace listing submission
 * @summary Delete store submission
 */
export const deleteV2DeleteStoreSubmission = async (
  submissionId: string,
  options?: RequestInit,
): Promise<deleteV2DeleteStoreSubmissionResponse> => {
  return customMutator<deleteV2DeleteStoreSubmissionResponse>(
    getDeleteV2DeleteStoreSubmissionUrl(submissionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV2DeleteStoreSubmissionMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>,
    TError,
    { submissionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>,
  TError,
  { submissionId: string },
  TContext
> => {
  const mutationKey = ["deleteV2DeleteStoreSubmission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>,
    { submissionId: string }
  > = (props) => {
    const { submissionId } = props ?? {};

    return deleteV2DeleteStoreSubmission(submissionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV2DeleteStoreSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>
>;

export type DeleteV2DeleteStoreSubmissionMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete store submission
 */
export const useDeleteV2DeleteStoreSubmission = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>,
      TError,
      { submissionId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV2DeleteStoreSubmission>>,
  TError,
  { submissionId: string },
  TContext
> => {
  return useMutation(
    getDeleteV2DeleteStoreSubmissionMutationOptions(options),
    queryClient,
  );
};
